import { api } from '../config'

export const FEEDBACK_URL = {
  get_complaint: (page: number, limit: number) =>
    `${api.withAPI}/admin/complaint/?page=${page}&limit=${limit}`,
  get_inaccuracy: (page: number, limit: number) =>
    `${api.withAPI}/admin/complaint/inaccuracy/?page=${page}&limit=${limit}`,
  deleteComplaint: (id: string) => `${api.withAPI}/admin/complaint/${id}`,
  getComplaintById: (id: string) => `${api.withAPI}/admin/complaint/${id}`,
  get_proposal: (page: number, limit: number) =>
    `${api.withAPI}/admin/proposal/?page=${page}&limit=${limit}`,
  deleteProposal: (id: string) => `${api.withAPI}/admin/proposal/${id}`,
  getProposalById: (id: string) => `${api.withAPI}/admin/proposal/${id}`,
  getInaccuracyById: (id: string) => `${api.withAPI}/admin/complaint/${id}`,
}
